// extracted by mini-css-extract-plugin
export var displayNone = "_r2-6";
export var imgContainer = "_r2-2";
export var overflowHidden = "_r2-3";
export var productInfoCardButtonContainer = "_r2-5";
export var productTitleText = "_r2-4";
export var rightArrow = "_r2-1";
export var rightArrowContainer = "_r2-0";